import { Card, Grid, Typography } from '@mui/material';

import { formatCurrency } from '@/shared';

export type TotalValoresProductosGridProps = {
  calcSubTotal: () => string;
  calcTotalTaxes: () => string;
  calcTotal: () => string;
};

const TotalValoresProductosGrid: React.FC<TotalValoresProductosGridProps> = ({
  calcSubTotal,
  calcTotalTaxes,
  calcTotal,
}) => {
  return (
    <>
      <Grid item xs={12}>
        <Card
          // variant="outlined"
          sx={{ px: 2, py: 4, borderRadius: 1, marginTop: 2 }}
        >
          <Grid item container gap={2} >
            {/* --------- subtotal & taxes --------- */}
            <Grid item xs={12} md={12} alignContent={"end"} alignItems={"end"} textAlign={"right"}>
              <Grid container gap={1}>
                {/* ---- subtotal ---- */}
                <Grid
                  item
                  container
                >
                  <Grid item md={8} textAlign={"right"}>
                    <Typography>SUBTOTAL</Typography>
                  </Grid>
                  <Grid item md={4} textAlign={"right"}>
                    <Typography >
                      {formatCurrency(calcSubTotal())}
                    </Typography>
                  </Grid>
                </Grid>
                
                {/* ---- taxes ---- */}
                <Grid
                  item
                  container
                >
                  <Grid item md={8} textAlign={"right"}>
                    <Typography>IMPUESTOS</Typography>
                  </Grid>
                  <Grid item md={4} textAlign={"right"}>
                    <Typography >
                      {formatCurrency(calcTotalTaxes())}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* --------- total --------- */}

            <Grid
              container
              item
            >
              <Grid item md={8} textAlign={"right"}>
                <Typography>TOTAL</Typography>
              </Grid>
              <Grid item md={4} textAlign={"right"} >
                <Typography variant='h5'>
                  {formatCurrency(calcTotal())}
                </Typography>
              </Grid>
            </Grid>


          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default TotalValoresProductosGrid;
